import React from 'react';
import {
	ReactHookFormNumberField,
	type ReactHookFormNumberFieldProps,
} from '@netx/core-components/Form/NumberField';
import type {ICustomFormItem, CustomFormFormValues} from '../../types';
import {
	getCustomFormItemTranslatedLabel,
	getCustomFormBaseFieldName,
} from '../../utils';

export interface ReactHookFormCustomFormItemNumberProps<
	TValues extends CustomFormFormValues = CustomFormFormValues,
> extends Omit<
		ReactHookFormNumberFieldProps<TValues>,
		'label' | 'name' | 'required'
	> {
	item: ICustomFormItem;
}

export const ReactHookFormCustomFormItemNumberPrimitive = <
	TValues extends CustomFormFormValues = CustomFormFormValues,
>({
	item,
	...props
}: ReactHookFormCustomFormItemNumberProps<TValues>) => {
	const {label, required} = item;

	return (
		<ReactHookFormNumberField
			fullWidth
			{...props}
			name={getCustomFormBaseFieldName(item)}
			required={required}
			label={getCustomFormItemTranslatedLabel(label)}
		/>
	);
};

export const ReactHookFormCustomFormItemNumber =
	ReactHookFormCustomFormItemNumberPrimitive;

export default ReactHookFormCustomFormItemNumber;
